<script setup>
import { onMounted, ref } from "vue";
import { ErrosRequest } from '../api/errorLogs';

import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import { FilterMatchMode } from '@primevue/core/api';


const activeSpinner = ref(false)
const dataSource = ref([]);
const columns = [
  { field: 'id_factura', header: 'IDFactura' },
  { field: 'nombre_negocio', header: 'Factura' },
  { field: 'nombre', header: 'Punto De Venta' },
  { field: 'status', header: 'Status' },
  { field: 'error_message', header: 'Error' },
  { field: 'error_message', header: 'Fecha' },
  { field: 'error_message', header: 'Hora' },
];

const loadData = async () => {
  activeSpinner.value = true;
  try {
    let result = await ErrosRequest()
    dataSource.value = result.data.data;
    activeSpinner.value = false;
  } catch (error) {
    console.log(error);
  }
}

const filters = ref({
  'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
});


onMounted(() => {
  loadData();
});
</script>

<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Configuracion Facturador</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2 mt-4">
      <Toolbar class="mb-6 m-3">
        <template #start>
          <Button label="Recargar" icon="pi pi-replay" severity="info" class="m-2" @click="loadData" />
        </template>
        <template #end>
          <IconField>
            <InputIcon>
              <i class="pi pi-search" />
            </InputIcon>
            <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
          </IconField>
        </template>
      </Toolbar>

      <div v-if="activeSpinner" class="flex justify-content-center align-items-center text-center mb-5">
        <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
      </div>

      <DataTable v-if="!activeSpinner" class="m-3 text-center" :value="dataSource" :paginator="true" :rows="5"
        :rowsPerPageOptions="[5, 10, 20, 50]" :filters="filters" stripedRows resizableColumns columnResizeMode="fit"
        showGridlines tableStyle="min-width: 50rem">
        <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header"></Column>
      </DataTable>

    </div>
  </div>
</template>

<style scoped>
.inputCreate {
  height: 3rem !important;
}
</style>
